'use strict';

const FetchHandler = require('../../deal/frontend/FetchHandler');

const displayCardsUserNeedsToClaimDeal = (
  userTypes,
  cashBack,
  buttonSelector
) => {
  const billingRecordTypes = cashBack
    ? cashBack.acceptableBillingRecordTypes
    : [];
  if (!userTypes || !userTypes.userConsentedTypes) {
    return null;
  }
  const userConsentedTypes = userTypes.userConsentedTypes;
  if (billingRecordTypes && billingRecordTypes.length) {
    const dealCardTypes = billingRecordTypes.reduce((arr, types) => {
      const { cardType } = types;
      if (cardType) {
        return arr.concat(cardType);
      }
      return arr;
    }, []);

    let typesNeeded = [];
    const inBoth = userConsentedTypes.filter(type =>
      dealCardTypes.includes(type)
    );

    if (!inBoth.length && userConsentedTypes.length) {
      typesNeeded = dealCardTypes;
    }

    if (typesNeeded.length) {
      const containerEl = document.querySelector('.eligible-cards-container');
      const messageEl = containerEl.querySelector('.message');

      containerEl
        .querySelector('.alert-icon')
        .insertAdjacentHTML(
          'afterend',
          window.I18n.t('js.modules.cash_back.to_claim')
        );

      messageEl.classList.add(...typesNeeded);

      containerEl.style.display = 'block';

      document.querySelector(buttonSelector).textContent = window.I18n.t(
        'js.modules.cash_back.enroll_and_claim'
      );
    }
  }
  return null;
};

const getUserBillingRecordTypes = (cb, data) => {
  const userBillingRecordTypesFetchHandler = new FetchHandler({
    successHandlers: userTypes => cb(userTypes, data),
    requestOpts: {
      credentials: 'include',
      method: 'get',
    },
    url: '/deals/proxy/user/valid_billing_record_types',
  });
  userBillingRecordTypesFetchHandler.send();
};

module.exports = {
  displayCardsUserNeedsToClaimDeal,
  getUserBillingRecordTypes,
};
